var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 117,
    viewBox: "0 0 145 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_444_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.449 91.3968L32.269 106.586C24.8876 107.777 19.3574 99.9695 22.9297 93.4013L62.0677 21.4396C64.9684 16.1062 72.2096 15.116 76.4356 19.4749L131.478 76.2469C136.544 81.4724 133.635 90.2379 126.449 91.3968Z",
    fill: "url(#paint0_linear_444_167)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.286 17.4142C102.067 16.6332 103.333 16.6332 104.114 17.4142L110.986 24.2858C111.767 25.0668 111.767 26.3332 110.986 27.1142L104.114 33.9858C103.333 34.7668 102.067 34.7668 101.286 33.9858L94.4142 27.1142C93.6332 26.3332 93.6332 25.0668 94.4142 24.2858L101.286 17.4142ZM108.165 27.1141C108.956 26.3348 108.96 25.0605 108.175 24.2754L104.125 20.2246C103.339 19.4395 102.065 19.4441 101.286 20.2349L97.2936 24.2859C96.5223 25.0685 96.5269 26.3269 97.3039 27.1039L101.296 31.0961C102.073 31.8731 103.331 31.8777 104.114 31.1064L108.165 27.1141Z",
    fill: "#108DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.682 69.8433C86.3078 70.2842 89.202 69.8242 91.2336 68.4633C93.9361 66.6617 93.9361 63.71 91.2336 61.9083C89.1828 60.5475 86.2503 60.0875 83.6245 60.5475M64.5785 69.8433C61.9527 70.2842 59.0585 69.8242 57.0269 68.4633C54.3244 66.6617 54.3244 63.71 57.0269 61.9083C59.0777 60.5475 62.0102 60.0875 64.636 60.5475M79.7355 76.245C76.688 74.2133 71.6472 74.2133 68.5805 76.245C65.878 78.0467 65.878 80.9983 68.5805 82.8C71.6472 84.8508 76.6689 84.8508 79.7355 82.8M85.6561 55.89C85.5355 55.8708 85.4126 55.8708 85.292 55.89C84.0128 55.8437 82.8018 55.302 81.9148 54.3792C81.0278 53.4564 80.5343 52.2249 80.5386 50.945C80.5386 48.2042 82.7428 46 85.4836 46C86.7951 46 88.0529 46.521 88.9803 47.4484C89.9076 48.3757 90.4286 49.6335 90.4286 50.945C90.4251 52.2259 89.9264 53.4557 89.037 54.3774C88.1475 55.299 86.9361 55.841 85.6561 55.89V55.89ZM62.6025 55.89C62.7175 55.8708 62.8516 55.8708 62.9666 55.89C64.2457 55.8437 65.4568 55.302 66.3438 54.3792C67.2308 53.4564 67.7243 52.2249 67.72 50.945C67.72 48.2042 65.5158 46 62.775 46C61.4635 46 60.2057 46.521 59.2783 47.4484C58.3509 48.3757 57.83 49.6335 57.83 50.945C57.8491 53.6283 59.9575 55.7942 62.6025 55.89ZM74.1561 70.2056C74.0355 70.1864 73.9126 70.1864 73.792 70.2056C72.5128 70.1593 71.3018 69.6176 70.4148 68.6948C69.5278 67.772 69.0343 66.5405 69.0386 65.2606C69.0386 62.5198 71.2428 60.3156 73.9836 60.3156C75.2951 60.3156 76.5529 60.8366 77.4803 61.7639C78.4076 62.6913 78.9286 63.9491 78.9286 65.2606C78.9095 67.9439 76.8011 70.1289 74.1561 70.2056Z",
    stroke: "#108DA0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_444_167",
    x: 11.8158,
    y: 6.73865,
    width: 132.21,
    height: 109.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_444_167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_167",
    x1: 7.08554,
    y1: 65.5731,
    x2: 136.414,
    y2: 44.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4FF99",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.1a32d25343fdea947c5b83c71edb5ea1.svg";
export { ForwardRef as ReactComponent };